import CryptoJS from 'crypto-js';

// Clé de cryptage pour les exports (à stocker de manière sécurisée en production)
// Cette clé est utilisée pour protéger les liens vers ADLS lors de l'export
const ENCRYPTION_KEY = process.env.REACT_APP_EXPORT_ENCRYPTION_KEY || 'GenIaC-Export-Secret-Key-2025';

/**
 * Crypte une chaîne de caractères en utilisant AES
 * @param text Texte à crypter
 * @returns Texte crypté en base64
 */
export function encryptString(text: string): string {
  if (!text) return text;

  try {
    const encrypted = CryptoJS.AES.encrypt(text, ENCRYPTION_KEY);
    return encrypted.toString();
  } catch (error) {
    console.error('Erreur lors du cryptage:', error);
    return text;
  }
}

/**
 * Décrypte une chaîne de caractères cryptée avec AES
 * @param encryptedText Texte crypté en base64
 * @returns Texte décrypté
 */
export function decryptString(encryptedText: string): string {
  if (!encryptedText) return encryptedText;

  try {
    const decrypted = CryptoJS.AES.decrypt(encryptedText, ENCRYPTION_KEY);
    return decrypted.toString(CryptoJS.enc.Utf8);
  } catch (error) {
    console.error('Erreur lors du décryptage:', error);
    return encryptedText;
  }
}

/**
 * Crypte les champs sensibles d'une architecture (file_path et file_url)
 * @param architecture Architecture à crypter
 * @returns Architecture avec champs cryptés
 */
export function encryptArchitectureBlobs(architecture: any): any {
  if (!architecture) return architecture;

  const encrypted = { ...architecture };

  // Crypter file_path si présent
  if (encrypted.file_path) {
    encrypted.file_path = encryptString(encrypted.file_path);
  }

  // Crypter file_url si présent
  if (encrypted.file_url) {
    encrypted.file_url = encryptString(encrypted.file_url);
  }

  return encrypted;
}

/**
 * Décrypte les champs sensibles d'une architecture (file_path et file_url)
 * @param architecture Architecture à décrypter
 * @returns Architecture avec champs décryptés
 */
export function decryptArchitectureBlobs(architecture: any): any {
  if (!architecture) return architecture;

  const decrypted = { ...architecture };

  // Décrypter file_path si présent
  if (decrypted.file_path) {
    decrypted.file_path = decryptString(decrypted.file_path);
  }

  // Décrypter file_url si présent
  if (decrypted.file_url) {
    decrypted.file_url = decryptString(decrypted.file_url);
  }

  return decrypted;
}

/**
 * Crypte un tableau d'architectures
 * @param architectures Tableau d'architectures
 * @returns Tableau avec architectures cryptées
 */
export function encryptArchitecturesBlobs(architectures: any[]): any[] {
  if (!Array.isArray(architectures)) return architectures;
  return architectures.map(arch => encryptArchitectureBlobs(arch));
}

/**
 * Décrypte un tableau d'architectures
 * @param architectures Tableau d'architectures cryptées
 * @returns Tableau avec architectures décryptées
 */
export function decryptArchitecturesBlobs(architectures: any[]): any[] {
  if (!Array.isArray(architectures)) return architectures;
  return architectures.map(arch => decryptArchitectureBlobs(arch));
}
